import React from "react";
// import { IQuestionsModel } from "../../models/DocModel";

interface IQuestionsListProps {
  questionsList?: string[];
  onQuestionClick?: (question: string) => void;
}

const QuestionsList = (props: IQuestionsListProps) => {
  const { questionsList, onQuestionClick } = props;

  return questionsList && questionsList?.length > 0 ? (
    <div className="questions-list">
      {questionsList?.map((each) => (
        <div
          key={each}
          className="question-item"
          onClick={() => onQuestionClick && each && onQuestionClick(each)}
        >
          {each || ''}
        </div>
      ))}
    </div>
  ) : (
    <></>
    // <div className="not-found">No questions found.</div>
  );
};

export default QuestionsList;
